import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit} from "@angular/core";
import {Widget} from "@ispm/widgets/decorator/widget.decorator";
import {IWidgetItem} from "@ispm/widgets/interfaces/widget-item.interface";
import {DynamicFormItem} from '@ispm/dynamic-form/classes/dynamic-form-item.class';
import {ITEMS_TYPES} from "@ispm/dynamic-form/constants/ItemsTypes";
import {IspmHttpClient} from "@ispm/core/services/ispm-http-client";
import {HttpInterceptorService} from "@ispm/core/services/http-interceptor.service";
import {Subject} from "rxjs";
import {FormGroup} from "@angular/forms";
import {UserActionCreatorService} from "@ispm/user/services/user-action-creator.service";
import {CryptoService} from "@ispm/migration/services/crypto.service";


@Component({
  selector: 'gen-decrypt-smtp',
  templateUrl: './decrypt-smtp.component.html',
  styleUrls: ['./decrypt-smtp.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@Widget('decrypt-smtp')
export class DecryptSmtpComponent implements OnInit, OnDestroy, IWidgetItem<any> {

  private key: string;
  private iterations: number;
  private _formConfig: Array<any>;
  public widgetFormInstance: FormGroup;
  private _widgetFormInstanceSubmitted: boolean;

  public widgetPayload:any;
  private destroyed$: Subject<any> = new Subject();
  public inputConfig= [];
  widgetUpdateValueCallback: (value) => void;
  public listenToDataChange = true;
  public data: any;
  public formData: any;

  constructor(private _ispmHttpClient: IspmHttpClient,
              private _isgHttpClient: HttpInterceptorService,
              private _changeDetector: ChangeDetectorRef,
              private _UserActionCreatorService: UserActionCreatorService,
              private cryptoService: CryptoService) {
  }

  ngOnInit() {
  }

  set widgetData(widgetData:any){
    this.data = widgetData;
  }
  set widgetConfig(widgetConfig) {

    this.widgetPayload = widgetConfig.widgetPayload;
    this._formConfig = this.widgetPayload.formConfig;
    this.inputConfig.push(Object.assign(
      DynamicFormItem.builder(
        this._formConfig[0].label || '',
        this._formConfig[0].name,
        ITEMS_TYPES.TEXT
      ).setCssClass("full-size-item form-item-column")
        .setAttributes(this._formConfig[0].attributes)
        .setRequired(this._formConfig[0].required), this._formConfig[0]

    ));
    this.inputConfig.push(Object.assign(
      DynamicFormItem.builder(
        this._formConfig[1].label || '',
        this._formConfig[1].name,
        ITEMS_TYPES.NUMBER
      ).setCssClass("full-size-item form-item-column")
        .setAttributes(this._formConfig[1].attributes)
        .setRequired(this._formConfig[1].required), this._formConfig[1]

    ));
    this.inputConfig.push(Object.assign(
      DynamicFormItem.builder(
        this._formConfig[2].label || '',
        this._formConfig[2].name,
        ITEMS_TYPES.TEXT
      ).setCssClass("full-size-item form-item-column")
        .setAttributes(this._formConfig[2].attributes)
        .setRequired(this._formConfig[2].required), this._formConfig[2]

    ));
  }


  public get widgetFormInstanceSubmitted(){
    return this._widgetFormInstanceSubmitted;
  }

  public formupdate(form){
    this.key = form.key;
    this.iterations = form.iteration;
  }

  public set widgetFormInstanceSubmitted(widgetFormInstanceSubmitted: boolean){
    this._widgetFormInstanceSubmitted = widgetFormInstanceSubmitted;
    this._changeDetector.markForCheck();
  };

  public decryptPassword() {
    let result = this.cryptoService.decrypt(this.data, this.key, this.iterations);
    const resultObj = {
      "key": this.key ,
      "iteration" : this.iterations,
      "result" : result};
    this.widgetUpdateValueCallback(resultObj);
    this.formData = resultObj;
    this._changeDetector.markForCheck();
  }


  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
    this._changeDetector.detach();
  }

}


